var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 111,
    viewBox: "0 0 122 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.4396C0 1.66307 1.44016 0.2229 3.2167 0.2229H17.6555C27.4465 0.2229 35.3837 8.16008 35.3837 17.9511C35.3837 27.7421 27.4465 35.6793 17.6555 35.6793H3.2167C1.44017 35.6793 0 34.2391 0 32.4626V3.4396Z",
    fill: "#00A3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6012 79.3955C39.6012 77.0096 41.5353 75.0754 43.9212 75.0754H69.3931C79.1841 75.0754 87.1213 83.0126 87.1213 92.8036C87.1213 102.595 79.1841 110.532 69.3931 110.532H43.9212C41.5353 110.532 39.6012 108.598 39.6012 106.212V79.3955Z",
    fill: "#00A3FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.0425,
    y: 37.6492,
    width: 35.6401,
    height: 35.4564,
    rx: 10,
    fill: "#EB002C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.1754,
    y: 37.6492,
    width: 63.0752,
    height: 35.4564,
    rx: 17.7282,
    fill: "#28A138"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.98041,
    y: 75.0754,
    width: 35.6401,
    height: 35.4564,
    rx: 17.7282,
    fill: "#FF9E00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.6012,
    y: 0.223145,
    width: 47.5201,
    height: 35.4564,
    rx: 17.7282,
    fill: "#7542E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e26e5bb0ed11d22ae71fc71c3ca4dfb.svg";
export { ForwardRef as ReactComponent };